import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Container } from 'react-bootstrap'
// import "./styles/purchaseOrders-styles.scss"
import PurchaseOrdersTableTopBar from './includes/PurchaseOrdersTable/PurchaseOrdersTableTopBar'
import PurchaseOrdersTable from './includes/PurchaseOrdersTable/PurchaseOrdersTable'
import SectionLoading from 'utlis/helpers/SectionLoading/SectionLoading'
import Pagination from 'components/CommonComponents/Pagination'
import { debounce } from 'utlis/helpers/Common/CommonHelperFunctions'
import {
    CONFIRMATION_BEFORE_DELETING_BRAND,
} from 'utlis/AppMessages/AppMessages'
import { getOders } from 'utlis/Apis/PurchaseOrder_API'
import { ERROR_WHILE_FETCHING_BRANDS } from 'utlis/AppMessages/AppMessages'
import { toast } from 'react-toastify'
import { ERROR_WHILE__NAME } from 'utlis/AppMessages/AppMessages'
import { UNKNOWN_ERROR_OCCURED } from 'utlis/AppMessages/AppMessages'
import useQueryHook from 'utlis/CustomHooks/useQueryHook'
import useStoreUrl from 'utlis/CustomHooks/useStoreUrl'


function PurchaseOrders(props) {
    // props
    const { authState } = props
    
    const loadingCount = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
    const [saleOrders, setPurchaseOrders] = useState([])
    const [loading, setLoading] = useState(false)
    const [allCheckboxSelected, setAllCheckboxesSelected] = useState(false)
    const [column__saleOrderNumber, setColumn__saleOrderNumber] = useState(true)
    const [column__saleDate, setColumn__saleDate] = useState(true)
    const [column__vendors, setColumn__vendors] = useState(true)
    const [column__requestQuantity, setColumn__requestQuantity] = useState(true)
    const [column__receivedQuantity, setColumn__receivedQuantity] = useState(true)
    const [column__total, setColumn__total] = useState(true)
    const [column__status, setColumn__status] = useState(true)

    const [sectionLoadingVisible, setSectionLoadingVisible] = useState(false)

    const [searchQuery, setSearchQuery] = useState("")

    let queryy = useQueryHook();

    // store url
    const [storeUrl] = useStoreUrl()

    useEffect(() => {
        let page = queryy.get('page')
        let keyword = queryy.get('keyword')

        let query = `${(keyword) ? "keyword=" + keyword + "&" : ""}${page ? "page=" + page : ""}`
        const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }
        getOders(headers, query).then(res => {
            setSectionLoadingVisible(false)
            setLoading(false)
            const resData = res.data
            // scroll the page to the top
            window.scrollTo(0, 0)
            if (resData && resData.success) {
                // setPaginationLinks(resData.links)
                setPurchaseOrders(resData.data)
            }
            if (resData && resData.error) {
                console.log(ERROR_WHILE_FETCHING_BRANDS, resData)
                toast.dismiss();
                toast.error(ERROR_WHILE_FETCHING_BRANDS, {
                    autoClose: 3000,
                    onClose: () => {
                        // disabling loading
                        setLoading(false)
                    }
                })
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} get saleOrders `, err.message)
            toast.dismiss();

            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500,
                onClose: () => {
                    setSectionLoadingVisible(false)
                    setLoading(false)
                }
            })
        })
    }, [props])

    const handleSelectAllChange = (ev) => {
        const checkboxes = document.getElementsByClassName('all-checkboxes-selector-checkbox')
        setAllCheckboxesSelected(!allCheckboxSelected)
        setTimeout(() => {
            if (ev.target.checked) {
                checkboxes.length && Array.from(checkboxes).forEach(checkbox => {
                    checkbox.checked = true
                });
            } else {
                checkboxes.length && Array.from(checkboxes).forEach(checkbox => {
                    checkbox.checked = false
                });
            }
        }, 50);

    };

    // deleting
    const handleDelete = (ev, brandId) => {
        ev.preventDefault()
        var confirmation = window.confirm(CONFIRMATION_BEFORE_DELETING_BRAND)

        if (confirmation) {
            setSectionLoadingVisible(true)
            // const headers = {
            //     "Authorization": `Bearer ${authState.commonToken}`,
            //     "Api-Token": authState.apiToken,
            //     "Access-Token": "",
            //     // "Store-Id": authState.storeId,
            // }
            // deleteBrand(headers, brandId).then(res => {
            //     setSectionLoadingVisible(false)
            //     const deletedData = res.data
            //     if (deletedData.success) {
            //         const filteredList = saleOrders.filter(item => item.manufacturer_id !== brandId)
            //         setBrands(filteredList)
            //         // dismissing all the previous toasts first
            //         toast.dismiss();
            //         toast.success(BRAND_DELETED_SUCCESSFULLY, {
            //             autoClose: 2500,
            //             onClose: () => {
            //             }
            //         })
            //     }
            //     if (deletedData.error) {
            //         console.log(ERROR_WHILE_DELETING_BRAND, res)
            //         toast.dismiss();
            //         toast.error(ERROR_WHILE_DELETING_BRAND, {
            //             autoClose: 2500,
            //         })
            //     }
            // }).catch(err => {
            //     console.log(`${ERROR_WHILE__NAME} deleteBrand `, err.message)
            //     toast.dismiss();
            //     toast.error(UNKNOWN_ERROR_OCCURED, {
            //         autoClose: 2500,
            //         onClose: () => {
            //             setSectionLoadingVisible(false)
            //         }
            //     })
            // })
        }
    }
    const handleSearchChange = debounce(ev => {
        let searchQueryValue = ev.target.value
        setSectionLoadingVisible(true)
        if (searchQueryValue && searchQueryValue.length) {
            setSearchQuery(searchQueryValue)
            props.history.push(`/my-sales/sale-orders?keyword=${searchQueryValue}&page=1`)
        }

        if (!searchQueryValue) {
            setSearchQuery("")
            props.history.push(`/my-sales/sale-orders?page=1`)
        }
    }, 500)

    return (
        <section id="app-saleOrders" className="st-def-mar-TB">
            <Container fluid className="st-container">
                <div className="app-saleOrders">
                    <div className="app-header-wrapper d-flex mb-2">
                        <p className="app-heading text-capitalize">Purchase Orders</p>
                    </div>
                    <div className="app-content-container">
                        <div className="app-card">
                            <div className="app-card-content bg-white border st-border-light st-default-rounded-block mb-3">
                                <div className="acc_top-bar border-bottom st-border-light">
                                    <PurchaseOrdersTableTopBar
                                        column__saleOrderNumber={column__saleOrderNumber}
                                        column__saleDate={column__saleDate}
                                        column__vendors={column__vendors}
                                        column__requestQuantity={column__requestQuantity}
                                        column__receivedQuantity={column__receivedQuantity}
                                        column__total={column__total}
                                        column__status={column__status}

                                        setColumn__saleOrderNumber={setColumn__saleOrderNumber}
                                        setColumn__saleDate={setColumn__saleDate}
                                        setColumn__vendors={setColumn__vendors}
                                        setColumn__requestQuantity={setColumn__requestQuantity}
                                        setColumn__receivedQuantity={setColumn__receivedQuantity}
                                        setColumn__total={setColumn__total}
                                        setColumn__status={setColumn__status}

                                        handleSearchChange={handleSearchChange}
                                    />
                                </div>

                                <div className="st-listing-table saleOrders-table">
                                    <PurchaseOrdersTable
                                        allCheckboxSelected={allCheckboxSelected}
                                        handleSelectAllChange={ev => handleSelectAllChange(ev)}
                                        saleOrders={saleOrders}
                                        column__saleOrderNumber={column__saleOrderNumber}
                                        column__saleDate={column__saleDate}
                                        column__vendors={column__vendors}
                                        column__requestQuantity={column__requestQuantity}
                                        column__receivedQuantity={column__receivedQuantity}
                                        column__total={column__total}
                                        column__status={column__status}

                                        loadingCount={loadingCount}
                                        loading={loading}
                                        handleDelete={(ev, id) => handleDelete(ev, id)}
                                    />

                                    {
                                        sectionLoadingVisible && (
                                            <SectionLoading />
                                        )
                                    }
                                </div>
                            </div>

                            <div className="pagination-container d-flex justify-content-end">
                                <Pagination
                                    searchQuery={searchQuery}
                                    routeName={storeUrl + "/my-sales/sale-orders"}
                                // paginationLinks={paginationLinks}
                                />
                            </div>
                        </div>

                    </div>
                </div>
            </Container>
        </section>
    )
}

const getDataFromStore = state => {
    return {
        authState: state.auth,
    };
}

// const dispatchActionsToProps = dispatch => {
//     return {
//         functionsData: (prop) => dispatch(functionsData(prop)),
//     }
// }

export default connect(getDataFromStore, null)(PurchaseOrders)